import { ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
}

export function DetailSection(props: Props) {
  const { title, children } = props;

  return (
    <div className="bg-onlight-bg-1 dark:bg-ondark-bg-1 rounded-lg p-6">
      <h3 className="text-onlight-text-1 dark:text-ondark-text-1 text-base font-semibold">
        {title}
      </h3>
      <div className="dark:divide-ondark-line-1 divide-onlight-line-1 divide-y">
        {children}
      </div>
    </div>
  );
}

export default DetailSection;
